import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const PrinterIcon = createSvgIcon(
  'PrinterIcon',
  <>
    <g clip-path="url(#clip0_990_19839)">
      <path
        d="M15.8337 6.66667H4.16699C2.78366 6.66667 1.66699 7.78333 1.66699 9.16667V14.1667H5.00033V17.5H15.0003V14.1667H18.3337V9.16667C18.3337 7.78333 17.217 6.66667 15.8337 6.66667ZM13.3337 15.8333H6.66699V11.6667H13.3337V15.8333ZM15.8337 10C15.3753 10 15.0003 9.625 15.0003 9.16667C15.0003 8.70833 15.3753 8.33333 15.8337 8.33333C16.292 8.33333 16.667 8.70833 16.667 9.16667C16.667 9.625 16.292 10 15.8337 10ZM15.0003 2.5H5.00033V5.83333H15.0003V2.5Z"
        fill={Color.White}
      />
    </g>
    <defs>
      <clipPath id="clip0_990_19839">
        <rect width="20" height="20" fill={Color.White} />
      </clipPath>
    </defs>
  </>,

  { viewBox: '0 0 20 20', style: { width: '20px', height: '20px' } },
);
